"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Filters = _interopRequireDefault(require("./filter/Filters"));

var _Scale = _interopRequireDefault(require("./Scale"));

var _Translation = _interopRequireDefault(require("./Translation"));

var _CreativeDocumentTransform = _interopRequireDefault(require("../creative-document/CreativeDocumentTransform"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNumber = _interopRequireDefault(require("../../utils/numbers/isNotNumber"));

var _creative = require("../../constants/creative");

var Transform = /*#__PURE__*/function () {
  /**
   * @type {number} - opacity
   */

  /**
   * @type {string} - Easing function of a transform
   */

  /**
   * @type {Filters} - Filters
   */

  /**
   * @type {number} - frame number
   */

  /**
   * @type {number} - rotation
   */

  /**
   * @type {Scale} - Scale of a transform
   */

  /**
   * @type {String} - the ID of the keyframe set this transform belongs to
   */

  /**
   * @type {Number} - the order this transform lives in the keyframe set
   */

  /**
   * @type {Translation} - Translation of a transform
   */
  function Transform(keyframe) {
    (0, _classCallCheck2["default"])(this, Transform);
    (0, _defineProperty2["default"])(this, "_alpha", void 0);
    (0, _defineProperty2["default"])(this, "_easingFunction", void 0);
    (0, _defineProperty2["default"])(this, "_filters", void 0);
    (0, _defineProperty2["default"])(this, "_keyframe", void 0);
    (0, _defineProperty2["default"])(this, "_rotation", void 0);
    (0, _defineProperty2["default"])(this, "_scale", void 0);
    (0, _defineProperty2["default"])(this, "_setId", void 0);
    (0, _defineProperty2["default"])(this, "_setOrder", void 0);
    (0, _defineProperty2["default"])(this, "_translation", void 0);

    if ((0, _isNotNumber["default"])(keyframe)) {
      throw new Error('Transform must have a valid keyframe');
    }

    this._keyframe = keyframe;
    this._alpha = _creative.DEFAULT_KEYFRAME_TRANSFORM.alpha;
    this._easingFunction = _creative.DEFAULT_KEYFRAME_TRANSFORM.easingFunction;
    this._filters = new _Filters["default"]();
    this._rotation = _creative.DEFAULT_KEYFRAME_TRANSFORM.rotation;
    this._scale = new _Scale["default"]();
    this._setId = _creative.DEFAULT_KEYFRAME_TRANSFORM.setId;
    this._setOrder = _creative.DEFAULT_KEYFRAME_TRANSFORM.setOrder;
    this._translation = new _Translation["default"]();
  }

  (0, _createClass2["default"])(Transform, [{
    key: "copy",
    value: function copy() {
      var transform = new Transform(this.keyframe);
      transform.alpha = this.alpha;
      transform.easingFunction = this.easingFunction;
      transform.rotation = this.rotation;
      transform.scale = this.scale.copy();
      transform.setId = this.setId;
      transform.setOrder = this.setOrder;
      transform.translation = this.translation.copy();
      return transform;
    }
  }, {
    key: "getCreativeDocumentTransform",
    value: function getCreativeDocumentTransform() {
      var creativeDocumentTransform = new _CreativeDocumentTransform["default"]();
      creativeDocumentTransform.alpha = this.alpha;
      creativeDocumentTransform.easingFunction = this.easingFunction;
      creativeDocumentTransform.filters = this.filters.toJSON();
      creativeDocumentTransform.rotation = this.rotation;
      creativeDocumentTransform.scale = this.scale.toJSON();
      creativeDocumentTransform.setId = this.setId;
      creativeDocumentTransform.setOrder = this.setOrder;
      creativeDocumentTransform.translation = this.translation.toJSON();
      return creativeDocumentTransform;
    }
    /**
     * Checks if object is an instance of Transform
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    },
    set: function set(value) {
      this._alpha = value;
    }
  }, {
    key: "easingFunction",
    get: function get() {
      return this._easingFunction;
    },
    set: function set(value) {
      this._easingFunction = value;
    }
  }, {
    key: "filters",
    get: function get() {
      return this._filters;
    },
    set: function set(value) {
      this._filters = value;
    }
  }, {
    key: "keyframe",
    get: function get() {
      return this._keyframe;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    },
    set: function set(value) {
      this._rotation = value;
    }
  }, {
    key: "scale",
    get: function get() {
      return this._scale;
    },
    set: function set(value) {
      this._scale = value;
    }
  }, {
    key: "setId",
    get: function get() {
      return this._setId;
    },
    set: function set(value) {
      this._setId = value;
    }
  }, {
    key: "setOrder",
    get: function get() {
      return this._setOrder;
    },
    set: function set(value) {
      this._setOrder = value;
    }
  }, {
    key: "translation",
    get: function get() {
      return this._translation;
    },
    set: function set(value) {
      this._translation = value;
    }
  }], [{
    key: "isTransform",
    value: function isTransform(inputObject) {
      return inputObject instanceof Transform;
    }
    /**
     * Return easing value between left and right blur transform
     *
     * @param {number} leftValue
     * @param {number} rightValue
     * @param {number} easingTime
     * @returns {number}
     */

  }, {
    key: "getEasingValue",
    value: function getEasingValue(leftValue, rightValue) {
      var easingTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if ((0, _isNotNumber["default"])(leftValue) || (0, _isNotNumber["default"])(rightValue) || (0, _isNotNumber["default"])(easingTime)) return 0;
      return leftValue + easingTime * (rightValue - leftValue);
    }
    /**
     * @param {number} keyframe
     * @param {CreativeDocumentTransform} creativeDocumentTransform
     * @returns {Transform}
     */

  }, {
    key: "fromCreativeDocumentObject",
    value: function fromCreativeDocumentObject(keyframe, creativeDocumentTransform) {
      if ((0, _isNotNumber["default"])(keyframe) || (0, _isNil["default"])(creativeDocumentTransform)) {
        return undefined;
      }

      var transform = new Transform(keyframe);
      transform.alpha = creativeDocumentTransform.alpha;
      transform.easingFunction = creativeDocumentTransform.easingFunction;
      transform.filters = _Filters["default"].fromJSON(creativeDocumentTransform.filters);
      transform.rotation = creativeDocumentTransform.rotation;
      transform.scale = _Scale["default"].fromJSON(creativeDocumentTransform.scale);
      transform.setId = creativeDocumentTransform.setId;
      transform.setOrder = creativeDocumentTransform.setOrder;
      transform.translation = _Translation["default"].fromJSON(creativeDocumentTransform.translation);
      return transform;
    }
  }]);
  return Transform;
}();

exports["default"] = Transform;